import { Box, Button, Container, Typography } from "@mui/material";
import theme from "../src/styles/theme";
import { useRouter } from "next/router";

export default function ElearningKaracsony() {
  const router = useRouter();
  return (
    <Container
      className="col pb-extra pt-extra"
      style={{ maxWidth: "80%" }}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography align="center" variant="h1" className="pt-huge">
        Köszöntünk a Dronecakes oldalán!
      </Typography>
      <Box width={{ xs: "100%", md: "90%", lg: "70%" }} sx={{ mt: 10 }}>
        <Typography variant="body1">
          Azért látod ezt az oldalt, mert bizonyára érdekel a drónozás világa,
          és kíváncsi vagy, vajon mi állhat a QR kód mögött?
        </Typography>
        <br />
        <Typography variant="body1">
          A Dronecakes a Loricatus Kft. mentorprogramja, azzal a céllal jött
          létre, hogy gyűjtőhelyként szolgáljon mind a kezdő, mind a haladó
          drónpilóták számára. Segítünk nekik munkát találni, és ha szeretnének
          komolyabban, professzionális szinten foglalkozni a drónozással,
          támogatjuk fejlődésüket, segítünk a kezdeti lépések megtételében.
        </Typography>
        <br />
        <Typography variant="body1">
          Az alábbi oldalon megismerkedhetsz újonnan induló online webináriumunk
          első két epizódjával, ami <b>Játsszunk 3D-ben!</b> Nevet kapta. Itt
          Aletta fog titeket elkalauzolni a háromdimenziós modellezés világában,
          valamint moderátorunk, Aleks kérdéseivel, egyes észervételeivel teszi
          színesebbé és interaktívvá az előadást. A teljes tanfolyam 24 epizódot
          ölel fel, és további szolgáltatásokat is tartalmaz: lehetőségetek van
          írásban, valamint a havonta egy alkalommal megtartott fogadóórán
          feltenni kérdéseiteket, útmutatást kérni Alettától, aki készségesen
          áll a rendelkezésetekre.
        </Typography>
        <br />
        <Typography variant="body1">
          Amennyiben felkeltettük az érdeklődésed, kérlek kattints az alábbi
          linkre, majd egy gyors regisztrációt követően lépj az Előfizetések
          fülre, ahol meg tudod adni a kuponkódod, amellyel ingyenesen elérhető
          lesz számodra a kurzus első havi anyaga 2022. december 24-től, mint
          karácsonyi ajándék. A kuponkód egyszeri használatra jogosít, és
          átruházható.
        </Typography>
        <br />
        <Typography variant="body1">
          Kellemes ünnepeket, és köszönjük a látogatást.
        </Typography>
        <br />
        <Typography variant="body1">
          Kattints ide, hogy elkezdd az ingyenes próbaidőszakot!
        </Typography>
        <Button
          sx={{
            maxWidth: 280,
            mt: 2,
            backgroundColor: theme.palette.primary.light,
          }}
          variant="contained"
          onClick={() => {
            router.push("/hu/register");
          }}
        >
          <Typography color="white">Mehet</Typography>
        </Button>
      </Box>
    </Container>
  );
}
